import {AppEvent} from '@esgillc/events';

@AppEvent({broadcast: true})
export class ParentConferencerChangedEvent {

}
